module.exports = __webpack_public_path__ + "public/adminIcons/adminReviews.svg?4149796a";